import { useTranslation } from 'react-i18next';
import { SectionStore } from '~/stores/sections';
import WidgetSection from '~components/Molecules/WidgetSection';
import { useCurrentLanguage } from '~hooks/language';
import { getAuthFromSearchParams } from '~utils/path/search_params';

function HealthDashboardPage() {
  const { t } = useTranslation();
  const [authKey] = getAuthFromSearchParams();
  const currentLanguage = useCurrentLanguage();

  const { metricsEnabled, recommendationsEnabled, mainEnabled, todosEnabled } = SectionStore();

  return (
    <>
      <main>
        <ip-session className="py-8 max-w-[1320px] mx-auto my-0" language={currentLanguage} action-token={authKey} use-iframe>
          {mainEnabled && (
            <WidgetSection title={t('section_title_main')}>
              <div className="h-fit flex flex-col gap-4 items-stretch w-full">
                <ip-main-widget></ip-main-widget>
              </div>
            </WidgetSection>
          )}

          {metricsEnabled && (
            <WidgetSection title={t('section_title_insights')} info={t('section_info_insights')}>
              <ip-metrics-module></ip-metrics-module>
            </WidgetSection>
          )}

          {(recommendationsEnabled || todosEnabled) && (
            <WidgetSection title={t('section_title_recommendations')}>
              {recommendationsEnabled && <ip-recommendations-widget></ip-recommendations-widget>}

              {todosEnabled && <ip-todos-widget></ip-todos-widget>}
            </WidgetSection>
          )}
        </ip-session>
      </main>

      <footer className="mx-auto pb-12 w-full px-8">
        <small className="max-w-[1320px]">{t('footer_disclaimer')}</small>
      </footer>
    </>
  );
}

export default HealthDashboardPage;
